var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.33301H8.625C5.97335 3.33301 4.64752 3.33301 3.82376 4.16985C3 5.00668 3 6.35355 3 9.04729V10.9521C3 13.6458 3 14.9927 3.82376 15.8295C4.64752 16.6663 5.97335 16.6663 8.625 16.6663H12.375C15.0267 16.6663 16.3525 16.6663 17.1762 15.8295C18 14.9927 18 13.6458 18 10.9521V9.04729C18 6.35355 18 5.00668 17.1762 4.16985C16.3525 3.33301 15.0267 3.33301 12.375 3.33301Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 6.66699H8.8335",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13.333H14.6667C14.0436 13.333 13.7321 13.333 13.5 13.199C13.348 13.1113 13.2217 12.985 13.134 12.833C13 12.601 13 12.2894 13 11.6663C13 11.0433 13 10.7317 13.134 10.4997C13.2217 10.3477 13.348 10.2214 13.5 10.1336C13.7321 9.99967 14.0436 9.99967 14.6667 9.99967H16.3333C16.9564 9.99967 17.2679 9.99967 17.5 10.1336C17.652 10.2214 17.7783 10.3477 17.866 10.4997C18 10.7317 18 11.0433 18 11.6663C18 12.2894 18 12.601 17.866 12.833C17.7783 12.985 17.652 13.1113 17.5 13.199C17.2679 13.333 16.9564 13.333 16.3333 13.333Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAlt);
export default __webpack_public_path__ + "static/media/wallet_alt.f253a970b5584ea9a56b61e02ccfe778.svg";
export { ForwardRef as ReactComponent };